export enum PLAN_STATUS {
  'ACTIVE' = 'ACTIVE',
  'EXPIRED' = 'EXPIRED'
}

export const WEB_BENEFIT_TYPE = 'can_access_web';
export const MOBILE_BENEFIT_TYPE = 'can_access_mobile';
